module.exports = __webpack_public_path__ + "img/cg.afbcd05e.svg";